import agentURL from '../lib/urlWriters/agentURL';
import agencyURL from '../lib/urlWriters/agencyURL';
import {addressFormatting} from '../lib/formatting';

export const agencySearchFormatter = (agencyList) => {
  if (agencyList && agencyList.status === 'success' && agencyList.agencyList != null) {
    let alc = agencyList.agencyList.content;
    alc.forEach((item, index) => {
      let isAgent = false;
      if (item.expandedLinks && item.expandedLinks.hasOwnProperty('agency')) isAgent = true;
      let logoitem;
      if (isAgent) {
        // agency URL
        item.agencyURL = agencyURL(item.expandedLinks.agency);
        // agent URL
        item.agentURL = agentURL(item, item.expandedLinks.agency);
        // agency Logo
        if (item.expandedLinks && item.expandedLinks.hasOwnProperty('agency') && item.expandedLinks.agency != null) logoitem = item.expandedLinks.agency.links.find((link) => {return link.rel == 'logo'});
        // agent headshot
        item.headshot = '/assets/images/headshot-placeholder-mui.svg';
        let headshot = item.links.find((link) => {return link.rel == 'headShot'});
        if (headshot && headshot.href != '') {
          item.headshot = headshot.href;
        }
      }
      else {
        // agency URL
        item.agencyURL = agencyURL(item);
        // agency Logo
        logoitem = item.links.find((link) => {return link.rel == 'logo'});
      }

      item.logoURL = '/assets/images/agency-logo-placeholder-mui.svg';
      if (logoitem && logoitem.href != '') {
        item.logoURL = logoitem.href;
      }

      let addr = item.address;
      if (!addr) {
        if (item.expandedLinks.agency) {
          item.address = item.expandedLinks.agency.address;
        }
      }
      item.address.formattedAddress = addressFormatting(item.address);
    });
  }

  return agencyList;
}
